import React, { useEffect, useRef } from "react";
import "./movingText.css";
import video from "./video/video.mp4";
import poster from "./video/poster.webp";
export default function MovingText() {
  return (
    <div className="movingText-main">
      <div className="movingText-wrapper">
        <div className="movingText-bg">
          <div className="movingText-mainText">
            <span>
              <b>merry Xmas</b>
            </span>
          </div>
        </div>
        <div className="rightText-wrapper">
          <div className="rightText">
            <span>CRĂCIUN FERICIT</span>
          </div>
          <div className="rightText rightText2">
            <span>BOLDOG KARÁCSONYT</span>
          </div>
        </div>
        <div className="leftText-wrapper">
          <div className="leftText ">
            <span>FROHE WEIHNACHTEN</span>
          </div>
          <div className="leftText leftText2">
            <span>ВЕСЕЛА КОЛЕДА</span>
          </div>
        </div>
      </div>
      <div className="movingText-video">
        <div
          className="catrinel-video"
          style={{ backgroundImage: `url(${poster})` }}
        >
          <video
            preload="none"
            //playsInline="true"
            // autoplay="true"
            // loop="true"
            controls="true"
            // muted="true"
            poster={poster}
            className="video-bg"
          >
            <source src={video} type="video/mp4 " />
          </video>
        </div>
      </div>
    </div>
  );
}
